import { useCallback, useEffect, useMemo, useState } from "react";
import { displayCallBackCountdown, displayTextWithOverflow } from "../../../../helper-functions";
import { CallBack } from "../../../../models";
import { Badge } from "react-bootstrap";

interface CallBackRowProps {
    callBack: CallBack;
    onClick: () => void;
}

export function CallBackRow({ callBack, onClick }: Readonly<CallBackRowProps>) {
    const { name, scheduledTime, userName, note } = callBack;
    const referral = callBack.case?.referral;

    const getMinutesDiff = useCallback(() => {
        const now = new Date();
        const timeDate = new Date(scheduledTime);
        const diffMs = timeDate.getTime() - now.getTime();
        return Math.floor(diffMs / 1000 / 60);
    }, [scheduledTime]);

    const [minutesDiff, setMinutesDiff] = useState(getMinutesDiff());

    useEffect(() => {
        const interval = setInterval(() => {
            setMinutesDiff(getMinutesDiff());
        }, 1000);
        return () => clearInterval(interval);
    }, [getMinutesDiff]);

    const timerColor = useMemo(() => {
        if (callBack.isComplete) return "white";
        if (minutesDiff > 1) return "success";
        if (minutesDiff > 0) return "warning";
        return "danger";
    }, [callBack.isComplete, minutesDiff]);

    const displayTime = useMemo(() => {
        const date = new Date(scheduledTime);
        return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes().toString().padStart(2, "0")}`;
    }, [scheduledTime]);

    if (!referral) return null;

    return (
        <tr className={`call-back-row clickable ${timerColor}`} onClick={onClick}>
            <td>
                <Badge
                    pill
                    bg={timerColor}
                    className={timerColor === "warning" || timerColor === "white" ? "text-dark" : ""}
                >
                    {callBack.isComplete ? "Completed" : displayCallBackCountdown(minutesDiff)}
                </Badge>
            </td>
            <td>
                <span className="text-nowrap">{name}</span>
                <br />
                {displayTime}
            </td>
            <td>
                Decedent:
                <br />
                <span className="text-nowrap fw-bold">
                    {referral.patientFirstName} {referral.patientLastName}
                </span>
            </td>
            <td>{displayTextWithOverflow(note, note, 75)}</td>
            <td>{userName}</td>
        </tr>
    );
}
